import { __awaiter } from "tslib";
import { getPageContextFromWindow } from '@fandom/context';
import { getToken } from 'pathfinder/store/appState';
import { ActionType } from 'sdk/models/Action/types';
import { getInterestForCurrentWiki } from './getInterestFromWiki';
function getCurrentFandomsIds() {
    var _a, _b, _c, _d, _e;
    return __awaiter(this, void 0, void 0, function* () {
        const userProfile = yield window.SilverSurferSDK.getUserProfile();
        const myFandoms = (_b = (_a = userProfile === null || userProfile === void 0 ? void 0 : userProfile.activeData) === null || _a === void 0 ? void 0 : _a.MYFANDOM) !== null && _b !== void 0 ? _b : [];
        let fandomIds = [];
        if (Array.isArray(myFandoms) && myFandoms.length === 1) {
            fandomIds = (_e = (_d = (_c = myFandoms[0]) === null || _c === void 0 ? void 0 : _c.payload) === null || _d === void 0 ? void 0 : _d.fandomIds) !== null && _e !== void 0 ? _e : [];
        }
        return fandomIds;
    });
}
export function hasCurrentWikiInMyFandoms() {
    return __awaiter(this, void 0, void 0, function* () {
        const fandom = getInterestForCurrentWiki();
        if (!fandom) {
            return false;
        }
        const fandomIds = yield getCurrentFandomsIds();
        return fandomIds.includes(fandom.id);
    });
}
export function getWikiVisitCount() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const wikiId = getPageContextFromWindow().productId;
        const userProfile = yield window.SilverSurferSDK.getUserProfile();
        const visitedWikis = ((_a = userProfile === null || userProfile === void 0 ? void 0 : userProfile.visitedProducts) === null || _a === void 0 ? void 0 : _a.mw) || {};
        return visitedWikis[wikiId];
    });
}
export function saveCurrentWikiToMyFandoms() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const fandomIds = yield getCurrentFandomsIds();
        const fandomId = (_a = getInterestForCurrentWiki()) === null || _a === void 0 ? void 0 : _a.id;
        if (!fandomId) {
            return;
        }
        if (fandomIds.find((element) => element == fandomId)) {
            return;
        }
        const newIds = [fandomId, ...fandomIds];
        // TODO: Test if this works for logged in users
        yield window.SilverSurferSDK.addActiveDataAction(getToken(), 'SetMyFandoms', ActionType.MYFANDOM, {
            fandomIds: newIds,
        });
    });
}
export function removeCurrentWikiFromMyFandoms() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const fandomIds = yield getCurrentFandomsIds();
        const fandomId = (_a = getInterestForCurrentWiki()) === null || _a === void 0 ? void 0 : _a.id;
        if (!fandomId) {
            return;
        }
        const newIds = fandomIds.filter((element) => element != fandomId);
        yield window.SilverSurferSDK.addActiveDataAction(getToken(), 'SetMyFandoms', ActionType.MYFANDOM, {
            fandomIds: newIds,
        });
    });
}
